import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import { map } from 'lodash';

import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table';

const stdColStyle = { width: '15%'};
const linkColStyle = { width: '40%'};

const tableStyle = {
  borderBottom: '1px solid rgb(224, 224, 224)'
};

@connect()
export default class PasswordResetsTable extends Component {

  static propTypes = {
    rows: PropTypes.array.isRequired,
    className: PropTypes.string,
  }

  constructor() {
    super();
  }

  renderRow(row, index) {
    return (<TableRow key={row.link} displayBorder data-id={`Row ${row.link}`}>
      <TableRowColumn className='column' style={stdColStyle} data-id={`Date ${index}`} >
        {row.dateCreated}
      </TableRowColumn>
      <TableRowColumn className='column' style={stdColStyle} data-id={`Account ${index}`} >
        {row.Account}
      </TableRowColumn>
      <TableRowColumn className='column' style={stdColStyle} data-id={`Email ${index}`} >
        {row.to}
      </TableRowColumn>
      <TableRowColumn className='column' style={stdColStyle} data-id={`First Name ${index}`} >
        {row.firstName}
      </TableRowColumn>
      <TableRowColumn className='column' style={linkColStyle} data-id={`Link ${index}`} >
        {row.link}
      </TableRowColumn>
    </TableRow >);

  }
  render() {
    const rows = this.props.rows;

    return (
      <div className={`password-resets-table ${this.props.className}`}>
        { rows.length > 0 &&
          <Table style={tableStyle} selectable={false} multiSelectable={false}>
            <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
              <TableRow>
                <TableHeaderColumn className='header-column' style={stdColStyle}>Date</TableHeaderColumn>
                <TableHeaderColumn className='header-column' style={stdColStyle}>Account</TableHeaderColumn>
                <TableHeaderColumn className='header-column' style={stdColStyle}>Email</TableHeaderColumn>
                <TableHeaderColumn className='header-column' style={stdColStyle}>First Name</TableHeaderColumn>
                <TableHeaderColumn className='header-column' style={linkColStyle}>Link</TableHeaderColumn>
              </TableRow>
            </TableHeader>
            <TableBody displayRowCheckbox={false}>
              {map(rows, ::this.renderRow)}
            </TableBody>
          </Table>
        }
        { !rows.length > 0 &&
          <div>No items found</div>
        }
    </div>);
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/Settings/PasswordResets/Landing/PasswordResetsTable/index.js